import { cn } from '@repo/tailwind-config/tailwind.functions'
import { tailwindColors } from '@repo/tailwind-config/tailwind.vars'
import Box from '@repo/ui/box'
import { ExclamationMarkIcon } from '@repo/ui/icons'
import Typography from '@repo/ui/typography'
import { useState } from 'react'
import { useFormContext } from 'react-hook-form'

import { HostFamilyInput } from '../../../lib/types/models/host-family/host-family-input'
import { FormControl, FormField, FormItem } from '../../elements/forms/form'
import InformationToolTip from '../../elements/information-tooltip'
import ControlledInput from '../../elements/inputs/controlled-input'
import ControlledRadioInput from '../../elements/inputs/controlled-radio-input'

const RoommateTooltip = () => {
  const [hovered, setHovered] = useState(false)
  return (
    <InformationToolTip
      icon={
        <div className="border border-secondary rounded-full h-5 w-5 flex items-center justify-center cursor-pointer">
          <div
            className={cn('rounded-full  h-4 w-4 flex items-center justify-center', {
              'bg-secondary': hovered
            })}
            onMouseEnter={() => setHovered(true)}
            onMouseLeave={() => setHovered(false)}
          >
            <ExclamationMarkIcon
              color={hovered ? tailwindColors.white.DEFAULT : tailwindColors.secondary.DEFAULT}
              height="10"
              width="10"
            />
          </div>
        </div>
      }
      align="center"
    >
      <Typography variant="label-medium" color={tailwindColors.white.DEFAULT}>
        If a shared room, max 3 years difference
      </Typography>
    </InformationToolTip>
  )
}

const HostFamilyStudentAccommodationForm = () => {
  const form = useFormContext<HostFamilyInput>()

  return (
    <Box className="bg-primary-light p-4 flex flex-col gap-4 rounded-xl">
      <Typography variant="text" color={tailwindColors.primary.DEFAULT}>
        Student accommodation
      </Typography>
      <div>
        <Typography variant="label-semibold" color={tailwindColors.grey.DEFAULT}>
          Student accommodation
        </Typography>
        <div className="h-2" />
        <div className="flex gap-4">
          <FormField
            control={form.control}
            name="isSharedRoom"
            render={({ field }) => {
              return (
                <FormItem>
                  <FormControl>
                    <ControlledRadioInput
                      {...field}
                      label={'Own room'}
                      checked={field.value === false}
                      onCheck={() => field.onChange(false)}
                    />
                  </FormControl>
                </FormItem>
              )
            }}
          />
          <FormField
            control={form.control}
            name="isSharedRoom"
            render={({ field }) => {
              return (
                <FormItem>
                  <FormControl>
                    <ControlledRadioInput
                      {...field}
                      label={'Shared room'}
                      checked={field.value === true}
                      onCheck={() => field.onChange(true)}
                    />
                  </FormControl>
                </FormItem>
              )
            }}
          />

          <RoommateTooltip />
        </div>
      </div>

      <FormField
        control={form.control}
        name="studentAccomodationComment"
        render={({ field }) => {
          return (
            <FormItem>
              <FormControl>
                <ControlledInput
                  {...field}
                  label="Comment"
                  type="textarea"
                  inputClassName="bg-primary-light"
                  labelClassName="bg-primary-light"
                />
              </FormControl>
            </FormItem>
          )
        }}
      />
    </Box>
  )
}

export default HostFamilyStudentAccommodationForm
